import { apiService } from '../../shared/services/apiService';
import {
  ChallengeTutorialVideo,
  ChallengeTutorialVideoStatus,
} from '../interface/challengeTutorial';

export const challengeTutorialService = {
  async getVideo() {
    const resp = await apiService.get<ChallengeTutorialVideo>(
      '/api/challenges/tutorial-video',
    );

    return resp.data;
  },

  async getShowStatus(userId: number) {
    const resp = await apiService.get<ChallengeTutorialVideoStatus>(
      `/api/users/${userId}/one-time-action/challenge-tutorial-video`,
    );

    return resp.data;
  },

  async updateShowStatus(userId: number, show: boolean) {
    const resp = await apiService.post<ChallengeTutorialVideoStatus>(
      `/api/users/${userId}/one-time-action/challenge-tutorial-video`,
      null,
      { params: { show } },
    );

    return resp.data;
  },
};
